<template>
  <div>
    <div>
      <v-select
        :items="ranges"
        v-model="range"
        label="Wybierz przedmiot analizy"
        solo
        hide-details
        prepend-inner-icon="mdi-calendar-range"
        class="shadoww"
      ></v-select>
    </div>
    <div v-if="range == 'custom'" class="pt-2 d-flex justify-space-between">
      <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="260px"
        class="mr-1"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            label="Picker without buttons"
            prefix="od"
            solo
            readonly
            hide-details
            v-on="on"
          ></v-text-field>
        </template>
        
        <v-date-picker v-model="date" @input="menu2 = false" no-title :locale="$i18n.locale"></v-date-picker>
      </v-menu>

      <v-menu
        ref="menu"
        v-model="menu3"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="260px"
        class="ml-1"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            label="Picker without buttons"
            prefix="do"
            solo
            readonly
            hide-details
            v-on="on"
          ></v-text-field>
        </template>
        
        <v-date-picker v-model="date" @input="menu2 = false" no-title :locale="$i18n.locale"></v-date-picker>
      </v-menu>
    </div>
    <div class="pt-6">
      <chart-line :data="lineData"></chart-line>
    </div>
  </div>
</template>

<script>
import ChartLine from '@/components/ChartLine.vue'

export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    menu3: false,
    ranges: [
      { text: 'Ostatnie 7 dni', value: '7d' },
      { text: 'Ostatnie 30 dni', value: '30d' },
      { text: 'Ostatanie 90 dni', value: '90d' },
      { text: 'Ostatani rok', value: '1y' },
      { text: 'Ostatanie 2 lata', value: '2y' },
      { text: 'Inny okres', value: 'custom' },
    ],
    range: '7d'
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    lineData() {
      return {
        labels: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        datasets: [{
          label: 'Temp. kotła',
          fill: false,
					backgroundColor: '#EF3024',
					borderColor: '#EF3024',
					data: [
						24,
						26,
						45,
						58,
						43,
						21,
            27,
            45,
						58,
						43,
						21,
            27,
            37
					],
				}, {
					label: 'Temp. CW',
					fill: false,
					backgroundColor: '#536DFE',
					borderColor: '#536DFE',
					data: [
						32,
						36,
						32,
						45,
						64,
						61,
            50,
            32,
						36,
						32,
						45,
						64,
						61
					],
				}]
      };
    }
  },
  created () {

  },
  components: {
    ChartLine
  }
}
</script>

<style>
canvas {
  width: 100% !important;
  height: auto;
}
</style>
